module.exports = __webpack_public_path__ + "static/media/zomato.b8040176.svg";